import React from 'react';
import Mixpanel from 'helpers/Mixpanel.js';
import { UserEntityBadge } from 'components/Global/Badges/';
import { EntityItemContainer, StyledEntityItem, EntityIcon } from './styled';

const EntityItem = ({ data = {}, dark, hideIcon, hideName, isUserEntity }) => {
  const { public_id, name, logo_url, type } = data;
  return (
    <EntityItemContainer
      onClick={() => {
        Mixpanel.track(`clicked ${type}`, { public_id, name });
      }}
      to={`/blueprint/${type}/${public_id}`}
    >
      {!hideIcon ? <EntityIcon logo_url={logo_url} /> : null}
      {!hideName ? (
        <StyledEntityItem dark={dark} hideIcon={hideIcon}>
          {name}{isUserEntity ? <UserEntityBadge /> : null}
        </StyledEntityItem>
      ) : null}
    </EntityItemContainer>
  );
};

export default EntityItem;
